<template>
  <v-container>

    <v-layout
      text-xs-center
      wrap
      v-if="order"
    >
      <v-flex mb-4 xs12 text-xs-center>
            <Order :order="order" :paypal_direct="true" />
      </v-flex>
      <v-flex mt-2 xs12>
	    <v-btn :to="`/events/${this.$route.params.event_id}`"> 이벤트 첫화면 / Event Home Page</v-btn>
	    <v-btn :to="`/events/${this.$route.params.event_id}/`">추가 신청하기 / Add Items</v-btn>
	    <v-btn :to="`/events/${this.$route.params.event_id}/orders`">신청내역 / Review Orders</v-btn>
            <div v-if="can_cancel(order)" style='margin-top: 5em'>
                <v-btn  :disabled="disable_cancel_button"  color="warning" @click="cancel_order" >주문 취소 / Cancel Order</v-btn>
            </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import Order from '@/components/Order';
import {fetcher} from '@/fetcher.js';

export default {
  components: {Order},
  data: () => ({
    event: {}, 
    link_code: '--',
    disable_cancel_button: false,
  }),
  beforeMount: async function() {
    this.$store.dispatch('loadEventOrders', {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch('loadEventSalesChannels', {
      event_id: this.$route.params.event_id,
    });
    this.$store.dispatch('loadEventProducts', {
      event_id: this.$route.params.event_id,
    });
  },
  mounted: () => {},
  computed: {
    ...mapState(['event_products', 'event_sales_channels', 'event_orders']),
    order() {
      return this.event_orders?.find(x => {
        return x.id == this.$route.params.order_id;
      });
    },
  },
  methods: {
    can_cancel: function(o) {
        return o.attendee_can_cancel
    },
    cancel_order: async function() {
      try {
        this.disable_cancel_button = true;
        let resp = await fetcher.post('/myprofile/cancel_event_order', {
          event_id: this.$route.params.event_id,
          order_id: this.$route.params.order_id,
        });
        console.log('cancel_event_order', resp);

        if (resp.data.success) {
            /*
            this.$router.push(
                `/events/${this.$route.params.event_id}/orders/${resp.data.order.id}`,
            );
            */
            this.$store.dispatch('loadEventOrders', {
              event_id: this.$route.params.event_id,
            });
        }
      } catch {
        this.message = 'Network error';
      } finally {
        setTimeout(() => {
          this.disable_cancel_button = false;
        }, 400);
      }
    },
      
  },
};
</script>

<style>
</style>
